module.exports = __webpack_public_path__ + "static/netflix-drm-b6d720bcbb3133e0d7d7b31a2e0eedfd.jpg";